import { Card, CardBody, Col } from "reactstrap";
import FormateLabelForm from "./FormateLabelForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { FormattedLabels } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const FormateLabel = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={FormattedLabels} span={BasicSliderData} />
        <CardBody>
          <FormateLabelForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default FormateLabel;
